import React from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuBasicsStyles/Congratulations.css';
import CtaLogo from '../../../../../../Assets/images/Logo/ctalogo.png';
import AppStoreButton from '../../Buttons/AppleStoreButton';
import GooglePlayButton from '../../Buttons/GoogleStoreButton';
import { useLanguage } from 'Core/Translations/LanguageContext';

interface CongratulationsProps {
    onSwitchTab: (tab: 'origins' | 'basics' | 'rules') => void;
}

const Congratulations: React.FC<CongratulationsProps> = ({ onSwitchTab }) => {
    const { t } = useLanguage();

    return (
        <div className="congratulations-container">
            {/* Header Section */}
            <div className="header-section">
                <h1 className="title">{t.beginnersGuide.basics.congratulations.title}</h1>
                <p className="subtitle">
                    {t.beginnersGuide.basics.congratulations.subtitle}
                </p>
            </div>

            {/* Next Steps Section */}
            <div className="next-steps-section">
                <div className="next-steps-content">
                    <h2 className="next-steps-title">{t.beginnersGuide.basics.congratulations.nextStepsTitle}</h2>
                    <p className="next-steps-text">
                        {t.beginnersGuide.basics.congratulations.nextStepsText}
                    </p>
                </div>

                <div className="cta-column">
                    <h3 className="cta-header">
                        {t.beginnersGuide.basics.congratulations.ctaHeader}{' '}
                        <strong className="cta-highlight">{t.beginnersGuide.basics.congratulations.ctaHighlight}</strong>
                    </h3>
                    <div className="platform-logo-wrapper">
                        <img
                            src={CtaLogo}
                            alt="Sudoku Game Logo"
                            className="platform-logo"
                        />
                    </div>
                    <div className="download-buttons-container">
                        <div className="store-button-wrapper">
                            <GooglePlayButton text={t.hero.googlePlay} />
                        </div>
                        <div className="store-button-wrapper">
                            <AppStoreButton text={t.hero.appStore} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Game Rules Section */}
            <div className="game-rules-section">
                <h2 className="game-rules-title">{t.beginnersGuide.basics.congratulations.rulesTitle}</h2>
                <p className="game-rules-text">
                    {t.beginnersGuide.basics.congratulations.rulesText.split('Sudoku VS: Game Rules')[0]}
                    <a
                        href="#"
                        className="rules-link"
                        onClick={(e) => {
                            e.preventDefault();
                            onSwitchTab('rules');
                        }}
                    >
                        {t.beginnersGuide.rulesTab}
                    </a>
                    {t.beginnersGuide.basics.congratulations.rulesText.split('Sudoku VS: Game Rules')[1]}
                </p>
            </div>
        </div>
    );
};

export default Congratulations;